<div class="mp-textarea {{size}} {{customClasses}}" [class.disabled]="disabled">
  @if (formControlField) {
    @if (formControlField.value) {
      <label
      class="mp-textarea-label" for="mp-form-control-textarea">{{label | translate}}</label>
    }
    <textarea id="mp-form-control-textarea"
      [readonly]="disabled"
      class="mp-textarea-field"
      [class.size-locked]="sizeLocked"
      [rows]="rows"
      [class.without-value]="!formControlField.value"
      placeholder="{{label | translate}}"
    [formControl]="formControlField"></textarea>
  }
  @if (!formControlField) {
    @if (textareaValue) {
      <label
      class="mp-textarea-label" for="mp-value-textarea">{{label | translate}}</label>
    }
    <textarea id="mp-value-textarea"
      [readonly]="disabled"
      class="mp-textarea-field"
      [class.size-locked]="sizeLocked"
      [class.without-value]="!textareaValue"
      [rows]="rows"
      placeholder="{{label | translate}}"
      [(ngModel)]="textareaValue"
    (ngModelChange)="onValueChanged()"></textarea>
  }
</div>



